'use client';

import { useState, useEffect } from 'react';

import { SESSION_BACK_NAVIGATION_FLAG } from '@constants/constants';
import { captureAppException } from '@utils/exception-logger';

export function useBackButtonLoader() {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const handlePopState = () => {
      setIsLoading(true);

      // Mark that the next shown route is reached via back navigation (used for BFCache mitigation and other logic)
      try {
        const payload = {
          path: window?.location?.pathname,
          search: window?.location?.search,
          ts: Date.now(),
        };
        sessionStorage.setItem(
          SESSION_BACK_NAVIGATION_FLAG,
          JSON.stringify(payload)
        );
      } catch (e) {
        console.error('[useBackButtonLoader] sessionStorage set failed:', e);
        captureAppException(e, 'useBackButtonLoader.sessionStorageSetFailed');
      }

      // Simulate some asynchronous operation
      setTimeout(() => {
        setIsLoading(false);
      }, 1000); // Adjust this timeout as needed
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  return isLoading;
}
